import useSWRV, { SWRVCache } from 'swrv';
import { computed, Ref } from '@vue/composition-api';
import { searchUsers } from '@/modules/advisor-search/api/useUsersApi';

const cache = new SWRVCache();

export const useUsersWithSWRV = (
  query: Ref<string>,
  page: Ref<number>,
  tracker?: (query: string, page: number, count: number) => void,
) => {
  const generateKey = () => `query:${query.value}, page:${page.value}`;

  const SWRV = useSWRV(
    generateKey,
    async (key: string) => {
      if (query.value === '') {
        return undefined;
      }

      const data = await searchUsers(query.value, page.value);

      if (tracker && !cache.get(key)) {
        tracker(query.value, page.value, data.meta.totalCount);
      }

      return data;
    },
    {
      revalidateOnFocus: false,
      cache,
    },
  );

  const isCached = computed(() => {
    // watcher の依存リストに SWRV.data を追加する
    SWRV.data.value;

    return !!cache.get(generateKey());
  });

  return {
    ...SWRV,
    isCached,
  };
};
